import { CircularProgress, Flex, Text } from '@shared/components';
export default function CertificateNavigatorLoading() {
  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100dvh',
        gap: (theme) => theme.spacing(4),
      }}
    >
      <CircularProgress size={100} />
      <Flex
        sx={{ flexDirection: 'column', alignItems: 'center', gap: (theme) => theme.spacing(2) }}
      >
        <Text variant='h3'>กำลังโหลดหนังสือรับรองผลการทดสอบ</Text>
        <Text sx={{ color: (theme) => theme.palette.secondary.dark }}>
          กรุณารอสักครู่ ระบบกำลังประมวลผล
        </Text>
      </Flex>
    </Flex>
  );
}
